import { useFireSessionContext } from '@chilipiper/fire-session'
import { useQuery } from '@tanstack/react-query'
import { queryKeyFactory as tenantsQueryKeyFactory } from '@chilipiper/tenants'
import { useApiClient } from './apiClientContext'

// Keyed with @chilipiper/tenants' factory: TenantPicker already fetched this on boot.
export const useTenantDetails = () => {
  const { tenantId } = useFireSessionContext()
  const { tenant } = useApiClient()

  return useQuery({
    queryKey: tenantsQueryKeyFactory.tenantDetails(tenantId),
    queryFn: () => tenant.getApiV1TenantsTenantid(tenantId),
  })
}
